import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledCurrentEmail, StyledCurrentEmailLabel, StyledNewEmail} from './style'
import {useTranslation} from '@/translations/i18n'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {SendVerificationEmailButton} from '@/features/account/components/send-verification-email-button/SendVerificationEmailButton'
import {CancelEmailChangeButton} from '@/features/account/components/cancel-email-change-button/CancelEmailChangeButton'
import {useEmailPendingVerification} from '@/features/account/hooks/useEmailPendingVerification'

interface AccountEmailPendingVerificationProps {
    currentEmail: string
    newEmail: string
    userId: string
}

export const AccountEmailPendingVerification = ({
    currentEmail,
    newEmail,
    userId
}: AccountEmailPendingVerificationProps) => {
    const {t} = useTranslation()
    const isPendingEmailVerification = useEmailPendingVerification()

    return (
        <Flexbox direction="column" gap={4} fullWidth>
            <Flexbox align="center" gap={3}>
                <StyledNewEmail>{newEmail}</StyledNewEmail>
                <Badge variant="orange">
                    <Flexbox gap={2} align="center">
                        {isPendingEmailVerification ? t('account:pending_validation') : t('account:to_verify')}
                        {isPendingEmailVerification && <Spinner />}
                    </Flexbox>
                </Badge>
            </Flexbox>

            <Flexbox direction="column">
                <StyledCurrentEmailLabel>{t('account:your_current_email_address')}</StyledCurrentEmailLabel>
                <StyledCurrentEmail>{currentEmail}</StyledCurrentEmail>
            </Flexbox>

            <Flexbox justify="space-between" fullWidth>
                <SendVerificationEmailButton isLoading={isPendingEmailVerification} userId={userId} />
                <CancelEmailChangeButton isLoading={isPendingEmailVerification} userId={userId} />
            </Flexbox>
        </Flexbox>
    )
}
